(function () {
  try {
    if (window.Shopify && Shopify.designMode) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var page = window.hvPage || '';
    var sectionPages = ['index', 'page', 'collection', 'list-collections', 'blog', 'article'];
    var gridPages = ['collection', 'search'];

    function init() {
      var targets = [];
      var vh = window.innerHeight || 800;

      if (sectionPages.indexOf(page) > -1) {
        document.querySelectorAll('main .shopify-section').forEach(function (s, i) {
          // erster Block (Hero) bleibt sofort sichtbar
          if (i === 0) return;
          if (s.getBoundingClientRect().top < vh * 0.5) return;
          s.setAttribute('data-hv-r', '');
          targets.push(s);
        });
      }

      if (gridPages.indexOf(page) > -1) {
        document.querySelectorAll('ul.product-grid:not(.slider) > li').forEach(function (li, i) {
          if (li.getBoundingClientRect().top < vh * 0.5) return;
          li.setAttribute('data-hv-r', '');
          li.style.setProperty('--hv-d', (i % 4) * 70 + 'ms');
          targets.push(li);
        });
      }

      if (!targets.length) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('hv-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });

      targets.forEach(function (t) { io.observe(t); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  } catch (err) { /* Animation ist optional */ }
})();
